import { render, staticRenderFns } from "./CardSectionAwards.vue?vue&type=template&id=0aa174b9"
import script from "./CardSectionAwards.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardSectionAwards.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports